export default __webpack_public_path__ + "static/media/mt_boxes.7d7ba9a5.svg";